<template>
  <Dialog v-model:open="open">
    <DialogContent class="max-w-[450px] flex flex-col max-h-[95vh] p-0 overflow-hidden">
      <div class="flex-1 min-h-0 overflow-y-auto p-4">
        <BoostStoreHowItWorks v-if="currentStep === 'how-it-works'" />
        <BoostStoreConfiguration v-else-if="currentStep === 'configuration'" />
        <BoostStoreBreakdown v-else-if="currentStep === 'breakdown'" />
        <BoostStoreEnterEmail v-else-if="currentStep === 'enter-email'" />
        <ContributeModal
          v-else-if="currentStep === 'contribute'"
          :order="order"
          @close="open = false"
          @completed="open = false"
        />
      </div>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import ContributeModal from '@/components/shopper/contribute/ContributeModal.vue';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { useWidgetStore } from '@/stores/widget';
import { computed, provide, ref, watch } from 'vue';
import type { ModelOrderResponse } from '@layup/api-sdk';
import BoostStoreBreakdown from './BoostStoreBreakdown.vue';
import BoostStoreConfiguration from './BoostStoreConfiguration.vue';
import BoostStoreEnterEmail from './BoostStoreEnterEmail.vue';
import BoostStoreHowItWorks from './BoostStoreHowItWorks.vue';
import { boostStoreModalKey, type BoostStoreStep } from './useBoostStoreModal';

const open = defineModel<boolean>('open', { required: true });

const props = defineProps<{
  storeId: string;
}>();

const widgetStore = useWidgetStore();

const currentStep = ref<BoostStoreStep>('how-it-works');

const order = computed<ModelOrderResponse>(() => widgetStore.order as ModelOrderResponse);

const goToStep = (step: BoostStoreStep) => {
  currentStep.value = step;
};

const close = () => {
  open.value = false;
};

watch(open, (isOpen) => {
  if (isOpen) {
    currentStep.value = 'how-it-works';
  }
});

provide(boostStoreModalKey, {
  goToStep,
  close,
  storeId: computed(() => props.storeId),
});
</script>
